// frontend/src/config.js
// Centralized app config. REACT_APP_API_URL is baked into the build by CRA.
// For development convenience, when NODE_ENV === 'development' default to the
// local backend at http://127.0.0.1:8000. 
const API_URL = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:8000' : `${window.location.protocol}//${window.location.host}`);

const CONFIG = { API_URL };

export default CONFIG;